import React, { FC } from 'react';
import { Link } from 'react-router-dom';

import FilterSelect from 'buyside/components/presentation/Filters/FilterSelect/filterSelect';
import FilterTextInput from 'buyside/components/presentation/Filters/FilterTextInput/filterTextInput';
import IndexFilterChips from 'buyside/components/presentation/IndexFilterChips/IndexFilterChips';
import StickyHeader from 'buyside/components/presentation/StickyHeader/stickyHeader';
import { MediaTypes } from 'buyside/components/presentation/MediaShowPage/mediaShowPage';

import styles from './mediaIndexPageStyles.scss';

const MediaIndexFilters: FC<{
  indexListResultCount: number;
  loading: boolean;
  mediaType: MediaTypes;
  mostPopularMediaHashtags: string[];
}> = ({ indexListResultCount, loading, mediaType, mostPopularMediaHashtags }) => {
  const filterOptions = [{ label: 'Published Date', value: '' }];

  if (mediaType === MediaTypes.VIDEO)
    filterOptions.push({ label: 'View Count', value: 'view_count' });

  return (
    <div className={styles.mediaIndexFilters}>
      <StickyHeader>
        {({ isSticky }: { isSticky: boolean }) => (
          <div className={isSticky ? styles.stickyContainer : null}>
            <IndexFilterChips />
            <FilterTextInput
              id="mediaIndexTextSearch"
              disabled={loading}
              paramName="text"
              placeholder={`Search ${mediaType}s`}
            />
          </div>
        )}
      </StickyHeader>
      {mostPopularMediaHashtags.length ? (
        <div className={styles.tags}>
          {mostPopularMediaHashtags.map(tag => (
            <Link key={tag} to={{ search: `?text=${tag}` }}>
              #{tag}
            </Link>
          ))}
        </div>
      ) : null}
      <div className={styles.resultSort}>
        <p>
          {`${loading ? '--' : indexListResultCount} result${
            indexListResultCount === 1 ? '' : 's'
          } sorted by`}
        </p>
        <FilterSelect borderless disabled={loading} options={filterOptions} paramName="sort_by" />
      </div>
    </div>
  );
};

export default MediaIndexFilters;
